export default "__VITE_ASSET__ijaMfRZm__"